export const FeatureFlagConstants = {
  // SAMPLE_FEATURE_FLAG: "sample_feature_flag",
  AWS_CONNECT_ENABLED: "aws_connect_enabled"
};
